var _rect, _path, _path2, _g, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgAdvanced8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 344,
    viewBox: "0 0 586 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_131_1267",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 586,
    height: 344
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 586,
    height: 344,
    rx: 15,
    fill: "#F4F8FF"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_131_1267)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.635 236.532C40.7213 234.647 -23 247.334 -23 247.334L-11.9679 360.395L487.025 358.51C487.025 358.51 312.55 239.64 142.66 236.532H142.635Z",
    fill: "#004DB9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_131_1267",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -23,
    y: 236,
    width: 511,
    height: 125
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.635 236.532C40.7213 234.647 -23 247.334 -23 247.334L-11.9679 360.395L487.025 358.51C487.025 358.51 312.55 239.64 142.66 236.532H142.635Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_131_1267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.416 363.274C309.416 363.274 273.11 332.041 243.504 317.672C218.382 305.469 179.502 288.299 199.35 280.707C219.198 273.115 229.873 262.976 208.013 257.804C186.178 252.633 138.762 252.582 138.915 246.824C139.068 241.067 150.584 242.493 148.393 237.806C146.202 233.118 135.883 229.399 135.883 229.399L130.1 229.246C130.1 229.246 140.342 235.284 136.826 237.5C133.31 239.717 122.839 241.78 121.514 248.684C120.189 255.588 150.075 262.11 159.12 270.44C166.738 277.446 156.47 284.248 136.495 296.451C117.794 307.89 55.2954 352.217 50.3271 365.974",
    fill: "#A8CAFF"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M146.394 45.0121C125.4 44.63 119.03 53.4191 85.8318 50.2347C59.3598 47.6871 47.2321 58.1831 45.3467 65.2908C43.0027 74.1818 51.8182 88.8813 94.2396 82.6653C142.241 75.6594 162.114 105.186 187.414 77.8249C197.86 66.5646 194.038 45.8783 146.394 45.0121Z",
    fill: "#FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M461.463 212.025C479.12 211.72 484.47 219.082 512.394 216.407C534.662 214.267 544.854 223.082 546.433 229.069C548.395 236.559 540.981 248.889 505.337 243.692C464.979 237.781 448.265 262.62 427.016 239.616C418.226 230.113 421.437 212.713 461.489 212L461.463 212.025Z",
    fill: "#FFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgAdvanced8);
export default __webpack_public_path__ + "static/media/bg-advanced8.bbff5a450ac4c8ffc8f3207f30ef98d2.svg";
export { ForwardRef as ReactComponent };